var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('TheHeader'),_c('TheNavigation',{key:_vm.navigationKey}),_c('TheContent'),_c('NotificationBar'),_c('DialogPopup'),_c('DialogLoader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }